module.exports = __webpack_public_path__ + "img/show2.cc3aecd4.png";